import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@material-ui/core';

export default function PromptMfaCode(
  {open, onClose, onConfirm}: {open: boolean, onClose: any, onConfirm: any}
) {
  // TODO: use form and type submit with required validation.
  const [code, setCode] = useState('');
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="prompt-mfa-code-title"
      aria-describedby="prompt-mfa-code-description"
    >
      <DialogTitle id="prompt-mfa-code-title">{"2FA authorization code"}</DialogTitle>
      <DialogContent>
        <TextField type="number"
          value={code}
          id="authorization-code"
          label="Authorization code"
          onChange={(e) => setCode(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={!code} onClick={() => {
          onConfirm(code);
          setCode('');
        }} variant="contained" color="secondary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}